'use strict';
import Common from '../../Utils/Common';

/**
 * @classname AnchorDeleteFavorite
 * @classdesc お気に入り削除ボタン
 */
export default class AnchorDeleteFavorite {
	/**
	 * @constructor
	 * @param {jQuery} $e - .anchor--delete-favorite
	 * @param {instance} controller - controller instance
	 */
	constructor($e, controller) {
		console.log(`${this.constructor.name}.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._itemId = $e.closest('.card--item').attr('data-item-id');
		$e.on('click', () => this.onClick());
		this._controller.on('onFavoriteComplete', () => {
			if(this._itemId == this._controller._itemId) {
				this.favoriteComplete();
			}
		});
		this._controller.on('onError', () => {
			this._controller._itemId = null;
		})
	};


	/**
	 * clickイベントのコールバック
	 *
	 * @memberof AnchorDeleteFavorite
	 * @return undefined
	 */
	onClick() {
		this._controller.favorite(this._itemId, false);
	};


	/**
	 * お気に入り処理完了
	 *
	 * @memberof AnchorDeleteFavorite
	 * @return undefined
	 */
	favoriteComplete() {
		console.log(`${this.constructor.name}.favoriteComplete`);
		this._controller._itemId = null;
		location.reload();
	};
};
